import { Box } from "@mui/material";
import React, {  useEffect, useState } from "react";
import { parseToEasternTime } from '../../../utils/dates';

export default function ProfileHeader({ user }) {
  const [date, setDate] = useState(null);

  useEffect(() => {
    const date = new Date(user.created);
    const dateTime = parseToEasternTime(date);
    setDate(dateTime);
  }, [user]);

  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap"}}>
      <Box className="container-image-card-profile">
        <div className="image-card-profile"></div>
        <Box className="data-card-profile">
          <Box className="header-data-profile">
            <p className="title-header-data-profile">{user.screenName}</p>
          </Box>

          <Box className="content-description-data-card-profile">
            <p className="description-data-profile">{user.firstName} {user.lastName}</p>
          </Box>

          <Box className="description-data-card-profile">
            <Box className="content-description-data-card-profile">
              <p className="description-data-profile">{user?.email}</p>
            </Box>
            <Box className="status-data-card-profile">
              {user?.isVerified ? (
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.7619 8.5L14.9029 6.37429L15.1619 3.56286L12.4114 2.9381L10.9714 0.5L8.38095 1.61238L5.79048 0.5L4.35048 2.93048L1.6 3.54762L1.85905 6.36667L0 8.5L1.85905 10.6257L1.6 13.4448L4.35048 14.0695L5.79048 16.5L8.38095 15.38L10.9714 16.4924L12.4114 14.0619L15.1619 13.4371L14.9029 10.6257L16.7619 8.5ZM6.92571 12.0962L4.03048 9.19333L5.1581 8.06571L6.92571 9.84095L11.3829 5.36857L12.5105 6.49619L6.92571 12.0962Z"
                    fill="var(--green)"
                  />
                </svg>
              ) : null}

              <p
                className={` ${user?.isVerified
                  ? "verified-car-profile success"
                  : "verified-car-profile done"
                  }`}
              >
                {user?.isVerified ? "Verified" : "noVerified"}
              </p>
            </Box>
          </Box>

          <Box className="description-data-card-profile">
            <Box className="content-description-data-card-profile-sm">
              <p style={{ fontSize: "var(--p2)", color: "var(--grey)", margin: '0' }}>
                Account Created: {date !== null ? date : null}
              </p>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row" }}>
        <div class="vertical-line"></div>
        <Box sx={{marginLeft: "15px"}}>
          <Box className="status-title-card-profile">Account Status</Box>
          <p
            style={{ fontSize: "1.25rem", fontWeight: "700", margin: '0' }}
            className={`status-user? button-${user?.status == "Inactive"
              ? "inactive"
              : user?.status == "Active"
                ? "active"
                : user?.status == "pending"
                  ? "pending"
                  : "unverified"
              }`}
          >
            {user?.status}
          </p>
        </Box>
        
      </Box>
    </Box>
  );
}